import { render } from "./ProjectsListUser.vue?vue&type=template&id=3923a2e5"
import script from "./ProjectsListUser.vue?vue&type=script&lang=js"
export * from "./ProjectsListUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__